export const confirmModalTranslationJP = {
  Confirm_Modal: {
    cancel: 'キャンセル',
    ok: 'OK',
  },
};
